import './App.css';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import NavBar from './components/navbar';
import { useEffect, useState } from 'react';
import { http_request } from './libs/connection';
import { getUserInfo } from './libs/lib';
import { BASE_ROUTE } from './config';

const INIT = 0;
const PROCESSING = 1;
const READY = 2;

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [APP_STATUS, setAppStatus] = useState(READY);
  const [user_info, setUserInfo] = useState({});

  useEffect(()=>{
    // initCSRF();
    initUser();
  }, [pathname]);

  function initUser(){
    let user = getUserInfo();
    setUserInfo(user);
    if(Object.keys(user).length === 0) navigate(`${BASE_ROUTE}/login`);
  }
  function initCSRF(){
    if(APP_STATUS === INIT){
      setAppStatus(PROCESSING);
      http_request('/sanctum/csrf-cookie', 'GET', {}, true).then(res=>{
        setAppStatus(READY);
      })
    }  
  }

  return <>
    <NavBar is_authenticated={user_info.access_token} />
    {
      (APP_STATUS === READY) && <Outlet />
    }
  </>
}

export default App;
